import { Button } from "@/components/ui/button";

export function BtnSocial({ icon, alt }: { icon: string, alt: string }) {
  return (
    <Button 
      type="button" 
      variant={"outline"} 
      size={"default"}
      className="border-0.5 border-gray-600 rounded-lg w-1/4 cursor-pointer hover:bg-transparent hover:border-purple-500"
      children={
        <img src={icon} alt={alt} className="w-4 h-4" />
      }
    />
  )
}